

















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';

import { User } from '../../models/userdata/userdto';

import router from '../../router';
import { UserParams } from '@/models/userdata/userparams';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import SignupFormV2 from './../Login/v2/SignupFormV2.vue';
import ResumeDetailsAnonApply from './../QuickApply/ResumeDetailsAnonApply.vue';
import { ResumeWrapper } from '@/models/jobs/resumeWrapper';
import { GenericLookup } from '@/models/utility/lookup';
import { ResumePayload } from '@/models/jobs/resumepayload';
import { JobApplication } from '@/models/jobs/jobapplication';
import GDPR from '../Registration/GDPR.vue';
import { RecaptchaResponse } from '@/models/referrals/recaptchaResponse';
import ReCaptcha from '../ReCaptcha/ReCaptcha.vue';
import AnonJobApplicationSuccess from './AnonJobApplicationSuccess.vue';
declare var window: any;
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 20000,
});

@Component({
  components: {
    SignupFormV2,
    ResumeDetailsAnonApply,
    GDPR,
    ReCaptcha,
    AnonJobApplicationSuccess,
  },
})
export default class QuickSignupForm extends Vue {
  private wlUser: User = new User();
  private userParams: UserParams = new UserParams();
  //$toastr: any;
  private socialRegistrationType: string = '';
  private noExample: boolean = true;

  private errors = {
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
  };
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  private selectedOption: GenericLookup = new GenericLookup();
  private resumePayload: ResumePayload = new ResumePayload();
  private uploadedResumeGUID: string = '';
  private isResumeActionComplete: boolean = false;
  private RESUME_UPLOAD_NOT_REQUIRED = '00';
  private RESUME_UPLOAD_MANDATORY = '01';
  private RESUME_UPLOAD_OPTIONAL = '02';
  private candidatePhone: string = '';
  private isGDPREnabled: boolean = true;
  private gdprObj = { marketingEmailFlag: false, tosEmailFlag: false };
  private applyPayload: JobApplication = new JobApplication();
  @Prop() jobPostingId;
  @Prop() resumeRequired;
  private recaptchaSizeValue: string = vxm.utility.isVisibleReCaptcha
    ? 'normal'
    : 'invisible';
  $toastr: any;
  private isApplied: boolean = false;

  get companyName(): String {
    return vxm.utility.companyName;
  }

  onRecaptchaExpired() {
    vxm.referrals.setRecaptchaResponse(new RecaptchaResponse());
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get isDisabled() {
    if (
      this.wlUser &&
      this.wlUser.email &&
      this.wlUser.firstName &&
      this.wlUser.lastName &&
      this.candidatePhone &&
      this.recaptchaValue
    ) {
      return false;
    }
    return true;
  }

  gdpr(gdprObj: any) {
    this.gdprObj = gdprObj;
    if (this.wlUser && gdprObj) {
      this.wlUser.marketingEmailFlag = gdprObj.marketingEmailFlag;
      this.wlUser.userAgreement = gdprObj.tosEmailFlag;
    }
  }

  get showWhatsApp() {
    return vxm.configs.whatsappNotificationEnabled
  }

  get globalRefCode() {
    const RefCode = vxm.referrals.globalRefCode;
    console.log('RefCode', [RefCode]);
    this.wlUser.referralUrl = RefCode;
    return RefCode;
  }

  validateRegistrationData(user: User, confirmPassword): boolean {
    this.errors = {
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
    };
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const hasNumber = user.password.match(/\d+/g);
    const hasLetter = user.password.match(/[a-zA-Z]/g);
    const hasUpperCase = user.password.match(/[A-Z]/g);
    const hasSpecialCharacter = user.password.match(/[*@!#%&()^~{}]+/g);

    let isValid: boolean = true;
    if (!user.email.match(emailformat)) {
      this.errors.email = 'signup.enter.valid.email';
    }
    if (!user.email) {
      this.errors.email = 'signup.email.required';
    }
    if (
      user.password.length <
        vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH') ||
      (hasNumber == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS')) ||
      hasLetter == null ||
      (hasUpperCase == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS')) ||
      (hasSpecialCharacter == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS'))
    ) {
      this.errors.password = vxm.utility.passwordConditions;
    }
    if (!user.password) {
      this.errors.password = 'signup.password.required';
    }
    if (user.password !== confirmPassword) {
      this.errors.confirmPassword = 'signup.password.confirmation.equivalent';
    }
    if (!user.firstName) {
      this.errors.firstName = 'signup.firstname.required';
    }
    if (!user.lastName) {
      this.errors.lastName = 'signup.lastname.required';
    }
    if (!user.phoneNumberValid) {
      this.errors.phone = 'signup.phone.valid';
    }
    if (!user.phone) {
      this.errors.phone = 'signup.phone.required';
    }
    Object.keys(this.errors).forEach((key) => {
      isValid = isValid && !this.errors[key];
    });
    return isValid;
  }

  get isSubmitBtnDisabled() {
    let falg =
      this.isDisabled && this.isGDPREnabled && (!this.gdprObj.tosEmailFlag || !this.gdprObj.marketingEmailFlag);
    console.log('Flag -> ' + falg);
    return falg;
  }

  landInPostSignupPage() {
    let homePage: any;
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      homePage = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (route) => route.sectionKey === 'HOME',
      );
    } else {
      homePage = vxm.jobs.BrandingInfo.leftMenu.slideMenuOptions.find(
        (route) => route.alias === 'home',
      );
    }
    const url = this.$cookies.get('NavigateTo_ID');

    if (
      vxm.utility.IsNewlyRegisteredUser &&
      this.$cookies.get('SubmitJobApplicationId') &&
      url
    ) {
      const [subpath, id] = url.split(':');
      this.$router.push({
        name: 'Jobdetails',
        params: { JobID: id },
      });
      return;
    } else if (
      vxm.utility.IsNewlyRegisteredUser &&
      vxm.configs.GuidedSignupEnabled
    ) {
      this.$router.push({ name: 'GuidedSignup' });
      return;
    } else if (url) {
      const [, id] = url.split(':');
      this.$router.push({
        name: 'Jobdetails',
        params: { JobID: id },
      });
      this.$cookies.remove('NavigateTo_ID');
      return;
    } else if (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_AFTER_SIGN_IN') === 'FIND_JOBS'
    ) {
      this.$router.push({ name: 'Findjobs' });
      return;
    }
    if (homePage && homePage.signInVisibility) {
      this.$router.push({ name: 'Home' });
      return;
    }
    this.$router.push({ name: 'Findjobs' });
  }

  updateCandidatePhone(event) {
    this.wlUser.phone =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.wlUser.phoneNumberValid = event.isValid;
  }

  postSignupAction(message) {
    vxm.utility.setIsNewlyRegisterdUser(true);
    this.$toastr('success', message, 'Sign Up');
    if (vxm.utility.useLoginSignupV2) {
      if (this.userParams.isSocialMediaSignup) {
        this.landInPostSignupPage();
      } else {
        this.$router.push({
          name: 'OTPLogin',
          params: { username: this.wlUser.userName },
        });
      }
    } else if (
      vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION') &&
      vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION').includes('1')
    ) {
      this.landInPostSignupPage();
    } else {
      this.$router.push({ name: 'AnonVerification' });
    }
  }
  showTermsAndConditionPopup() {
    this.$bvModal.show('terms-service-modal');
  }

  processResuemUpload2(resumePayload: ResumePayload) {
    if (!!resumePayload) {
      this.resumePayload = resumePayload;
    }
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  async register() {
    this.userParams.email = this.wlUser.userName;
    if (this.wlUser.firstName) {
      this.wlUser.firstName = this.wlUser.firstName.trim();
    }
    if (this.wlUser.lastName) {
      this.wlUser.lastName = this.wlUser.lastName.trim();
    }

    if (!this.wlUser.companyCode) {
      this.wlUser.companyCode = vxm.users.getCompanyCode;
    }

    if (!this.wlUser.userName) {
      this.wlUser.userName = this.wlUser.email;
    }

    this.userParams.firstName = this.wlUser.firstName;
    this.userParams.lastName = this.wlUser.lastName;
    this.userParams.phone = this.wlUser.phone;
    this.userParams.password = this.wlUser.password;

    if (this.validateOAuthRegistrationData(this.wlUser)) {
      const formData = new FormData();

      formData.append('user', JSON.stringify(this.wlUser));
      if (this.resumePayload && this.resumePayload.resumefile) {
        formData.append('resumefile', this.resumePayload.resumefile);
      }
      if (!this.jobPostingId) {
        this.$toastr('error', 'Job posting is undefined', '');
      }
      formData.append(
        'resume',
        '{"resumename": "", "resumeLink":"' +
          this.resumePayload.resumelink +
          '","jobpostingid":' +
          this.jobPostingId +
          '}',
      );

      const quickSignUpResponse = await vxm.users.quickUserRegister(formData);
      if (
        quickSignUpResponse &&
        quickSignUpResponse.data &&
        quickSignUpResponse.data.success &&
        quickSignUpResponse.data.userId
      ) {
        this.proceedAnonJobApplicationSubmission(
          quickSignUpResponse.data.userId,
          quickSignUpResponse.data.resumeGUID,
        );
      } else {
        this.$toastr('error', '', quickSignUpResponse.data.errorMessage);
        return;
      }
    }
  }

  proceedAnonJobApplicationSubmission(userId: number, resumeGUID: string) {
    const vm = this;
    if (this.jobPostingId) {
      vm.applyPayload.jobPostingId = parseInt(this.jobPostingId, 10);
    }
    vm.applyPayload.companyCode = vxm.jobs.BrandingInfo.companycode;
    vm.applyPayload.resumeGUID = resumeGUID;
    if (!userId) {
      this.$toastr(
        'error',
        'Something went wrong, User Info is missing!',
        'Job Application Submission',
      );
      return;
    }

    vm.applyPayload.userId = userId;

    const jobid = this.jobPostingId;
    const respPromise: any = vxm.jobs.anonApplyWithResumeGuid(vm.applyPayload);
    Promise.all([respPromise]).then(
      (values) => {
        if (values[0]) {
          if (values[0].nextPage === 'success') {
            vxm.jobs.setAppliedJob(jobid);
            const successMessage = this.$t('jobs.successfully.applied');
            this.$toastr('success', successMessage, this.$t('MyJobListing_JobApplication'));
            vxm.jobs.setAppliedJob(jobid);
            this.$emit('close');
            this.$router.push({
              name: 'AnonJobApplicationSuccess',
              params: { jobid },
            });

            this.isApplied = true;

            return;
          }

          if (
            values[0].nextPage === 'questionnaire' ||
            values[0].nextPage === 'supportinginfo' ||
            values[0].nextPage === 'timeslots'
          ) {
            this.setNavigation('JobDetails:' + jobid);
            this.$toastr(
              'info',
              this.$t('MyJobListing_JobApplication_LoginRequiredMessage'),
              this.$t('MyJobListing_JobApplication'),
            );
            this.$router.push({ name: 'Login' });
          }
        }
      },
      (err) => {
        this.$toastr(
          'error',
          this.$t('something.went.wrong'),
          this.$t('MyJobListing_JobApplication'),
        );
      },
    );
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
  }

  validateOAuthRegistrationData(user: User): boolean {
    let isValid: boolean = true;
    this.errors = {
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
    };
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!user.firstName) {
      this.errors.firstName = 'signup.firstname.required';
    }
    if (!user.lastName) {
      this.errors.lastName = 'signup.lastname.required';
    }
    if (!user.email.match(emailformat)) {
      this.errors.email = 'signup.enter.valid.email';
    }
    if (!user.email) {
      this.errors.email = 'signup.email.required';
    }
    if (!user.phoneNumberValid) {
      this.errors.phone = 'signup.phone.valid';
    }
    if (!user.phone) {
      this.errors.phone = 'signup.phone.required';
    }

    if (this.resumeRequired && !this.resumePayload.resumefile) {
      this.$toastr(
        'error',
        'Resume is mandatory for job application submission!',
        '',
      );
      return false;
    }
    Object.keys(this.errors).forEach((key) => {
      isValid = isValid && !this.errors[key];
    });
    return isValid;
  }
  setOAuthProvider(provider: string) {
    this.$cookies.set('OAuthProvider', provider, 300);
  }

  setOAuthRegistrationType(rtype: string) {
    console.log('C setOAuthRegistrationType:', rtype);
    this.$cookies.set('OAuthRegistrationType', rtype, 300);
  }
  getOAuthRegistrationType(): string {
    return this.$cookies.get('OAuthRegistrationType');
  }
  getOAuthProvider(): string {
    return this.$cookies.get('OAuthProvider');
  }
  get isPartialSignup() {
    console.log(vxm.users.isPartialSignup, 'partial signup');
    return vxm.users.isPartialSignup;
  }

  get duplicateCheckRequired() {
    console.log(
      'duplicate check required value is : ',
      vxm.users.UserParams.checkForDuplicate,
    );
    return vxm.users.UserParams.checkForDuplicate;
  }

  get populateSignupPage() {
    console.log(
      'populate signup page value is : ',
      vxm.users.UserParams.populateSignupPage,
    );
    return vxm.users.UserParams.populateSignupPage;
  }

  beforeMount() {
    if (
      vxm.configs.getGlobalConfigValue('ENABLE_ROLEBASED_REGISTRATION') &&
      window.WorkLLama.refId === 'null' &&
      window.WorkLLama.uuid === 'null'
    ) {
      this.$router.push({ name: 'RoleRegisterList' });
    }
  }

  get recaptchaValue(): boolean {
    return this.showRecaptcha ? vxm.referrals.RecaptchaResponse.success : true;
  }

  get showRecaptcha(): boolean {
    return false && vxm.utility.showSignUpReCaptcha;
  }
}
